import React, { memo, FC } from "react";
import PleaseNote from "../PleaseNote";
import SwingWidthAccordian from "../SwingConfiguration/Width/SwingWidthAccordian";
import SwingConfigs from "../SwingConfiguration/Config/SwingConfigs";
import ReusableAccordian from "../ReusableAccordion";
import Choices from "../Choices";
import EqualPanels from "../SwingConfiguration/EqualPanels/EqualPanels";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useConfigSelector from "./useConfigSelector";
import { sideliteOptions } from "./defaults";

const RowLayoutLeftDivide = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  borderLeft: `2px solid ${theme.palette.divider}`,
  padding: theme.spacing(1, 2),
}));

const StyledDivRowStart = styled("div")({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  flexWrap: "wrap",
});

const StyledDivRowStart2 = styled("div")({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  flexWrap: "wrap",
  width: 410,
  paddingTop: 20,
});

interface PivotConfigProps {
  editQuote: boolean;
  submitPressed: boolean;
}

const PivotConfigAccordian: FC<PivotConfigProps> = ({
  editQuote,
  submitPressed,
}) => {
  const {
    widthMeasureImg,
    setWidthMeasureImg,
    handleClickSLite,
    editBtn,
    sideLite,
  } = useConfigSelector(submitPressed, editQuote);

  return (
    <>
      <ReusableAccordian
        accordionName="swingDirection"
        heading="Configuration"
        secondaryHeading="Select Configuration"
        colOrRow="col"
        required5={true}
      >
        <PleaseNote notes="No warranty for water penetration, wind penetration, or airborne particles" />

        <RowLayout style={{ justifyContent: "flex-start", width: "100%" }}>
          <ColLayout
            style={{ width: "50%", alignItems: "flex-end", paddingRight: 80 }}
          >
            <StyledDivRowStart>
              {sideliteOptions.map((state) => (
                <div
                  key={state.id}
                  onClick={() => handleClickSLite(state.label)}
                >
                  <Choices
                    label={state.label}
                    variant={
                      state.label.toLowerCase() ===
                      sideLite?.replace("Add ", "").toLowerCase()
                        ? "filled"
                        : "outlined"
                    }
                    checkMark={
                      state.label.toLowerCase() ===
                      sideLite?.replace("Add ", "").toLowerCase()
                    }
                  />
                </div>
              ))}
            </StyledDivRowStart>

            {sideLite && sideLite !== "none" && (
              <StyledDivRowStart2>
                <EqualPanels isPivot={true} />
              </StyledDivRowStart2>
            )}
          </ColLayout>

          <RowLayoutLeftDivide style={{ paddingLeft: 80 }}>
            <SwingConfigs
              setWidthMeasureImg={setWidthMeasureImg}
              sType="Single Swing"
              sLite={sideLite || ""}
              swingDir="Inswing"
              isPivot={true}
            />
          </RowLayoutLeftDivide>
        </RowLayout>
      </ReusableAccordian>

      <SwingWidthAccordian
        widthMeasureImg={widthMeasureImg}
        editBtn={editBtn}
        sideLites={sideLite || ""}
        direction="Inswing"
        swingType="Single Swing"
        isPivot={true}
      />
    </>
  );
};

export default memo(PivotConfigAccordian);
